



















































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VehicleDetail from '@/models/VehicleDetail';
import CarDetail from '@/components/CarDetail.vue';
import OrderService from '@/services/order.service';
import OrderDetailModel from '@/models/OrderDetailModel';
import { SelectedAttributeModel } from '@/models/AttributeModel';
import eventBus from '@/common/bus';
import Shared from '@/common/shared';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';
import BaseServiceMixin from '@/mixins/base.service.mixin';

@Component({
  name: 'Order',
  components: {
    CarDetail,
  },
})
export default class Order extends Mixins(BaseServiceMixin) {
  private vehicleDetail: VehicleDetail = new VehicleDetail();
  private order: OrderDetailModel = new OrderDetailModel();
  private selectedAttributes: SelectedAttributeModel[] = [];
  private orderString: string = '';
  private store = getModule(StoreVuexModule, this.$store);
  private orderService!: OrderService;

  public created() {
    if ('token' in this.$route.params && this.$route.params.token !== '') {
      this.orderString = this.$route.params.token;
    } else {
      eventBus.$emit('errorHandler', Shared.messages.ORDER_NOT_FOUND, true);
      this.redirectBackToHome();
    }
    this.orderService = new OrderService(this.axiosInstance);
  }

  private mounted() {
    this.getOrder();
    // setTimeout(() => {
    //   this.redirectBackToHome();
    // }, Shared.redirectionTime);
  }

  private get storeName(): string {
    return this.store.currentConfig.name;
  }

  private get storeTitle(): string {
    return this.store.currentConfig.title;
  }

  private get showDetail() {
    return Object.keys(this.order.vehicle).length > 0;
  }

  private async getOrder() {
    const order: OrderDetailModel | null = await this.orderService.GetOrder(
      this.orderString,
    );

    if (order !== null) {
      Object.assign(this.order, order);
      this.vehicleDetail = this.order.toVehicleDetail;
      this.selectedAttributes = this.order.toSelectedAttributeModel;
    } else {
      eventBus.$emit('errorHandler', Shared.messages.ORDER_NOT_FOUND, true);
      this.redirectBackToHome();
    }
  }

  private redirectBackToHome() {
    this.$router.push({
      name: 'main',
    });
  }
}
